import { LocalStorage } from 'backbone.localstorage'
import { Defaults } from 'es-decorators'
import { Collection } from 'es6/components/collection'
import { Model } from 'es6/components/model'

const fakeStorage = {
  get: function () {},
  key: function () {},
  getItem: function () {},
  setItem: function () {},
  removeItem: function () {},
  clear: function () {},
  length: 15,
}

@Defaults({
  model: Model,
  localStorage: (function () {
    try {
      return new LocalStorage('search-tips-cache')
    } catch (e) {
      return fakeStorage
    }
  })(),
})
export class SearchTipsCache extends Collection {
  /**
   * Метод для получения времени записи в LS
   * @param {Model} element
   * @returns {string} time
   */
  comparator (element) {
    return element.get('time')
  }
}
